module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Combined.c83a1752.gif";